import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { allliststaff, grouplist, loancreate, loandatewise, memberdetail } from "../../../services/admin";
import { schemelist } from "../../../services/master";
import moment from "moment/moment";
export default function AddLoan() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [urllink, setUrllink] = useState("");
    const [dlist, setDlist] = useState([]);
    const [samt, setSamt] = useState("");
    const [ndues, setNdues] = useState("");
    const [pamt, setPamt] = useState("");
    const [iamt, setIamt] = useState("");
    const [tamt, setTamt] = useState("");


    const [grpid, setGrpId] = useState("");
    const [glist, setGlist] = useState([]);
    const [memid, setMemId] = useState("");
    const [mlist, setMlist] = useState([]);

    const [addr, setAddr] = useState("");
    const [phone, setPhone] = useState("");
    const [aadhar, setAadhar] = useState("");

    const [staff, setStaff] = useState("");
    const [slist, setSlist] = useState([]);

    const [schid, setSchId] = useState("");
    const [sclist, setSclist] = useState([]);

    const [ldate, setLDate] = useState("");
    const [dsdate, setDsDate] = useState("");
    const [entryfee, setEntryFee] = useState("");

    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        setLDate(moment(new Date()).format("YYYY-MM-DD"));
        setDsDate(moment(new Date()).format("YYYY-MM-DD"));
        const temp=new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                setGlist(res.data);
            }
        });

        memberdetail(id).then((res) => {
            if (res.status === true) {
                if (res.data.details !== null) {
                    setGrpId(res.data.details.group_id);
                    setMemId(res.data.details.member_name);
                    setPhone(res.data.details.phone_no);
                    setAadhar(res.data.details.aadhar_no);
                    setAddr(res.data.details.permanent_address);
                    setStaff(res.data.details.group_collection_staff);
                }
            }
        })
        allliststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setSlist(res.data.details);
            }
        });

        schemelist().then((res) => {
            if (res.status === true) {
                setSclist(res.data);
            }
        });

    }, []);


    const handleFee = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setEntryFee(e.target.value);
        }
    };
    const [psubmit, setPsubmit] = useState(false);
    const [perror, setPerror] = useState("");
    function handlesubmit(e) {
        e.preventDefault();
        setPerror("");
        setPsubmit(true);
        if (grpid !== "" && memid !== "" && staff !== "" && schid !== "" && ldate !== "" && dsdate !== "") {
            setLoading(true);
            const temp = new FormData();
            temp.append("loan_group", grpid);
            temp.append("loan_member", id);
            temp.append("loan_staff", staff);
            temp.append("loan_scheme", schid);
            temp.append("loan_date", ldate);
            temp.append("loan_due_date", dsdate);
            temp.append("loan_insurance", entryfee);
            loandatewise(temp).then((res) => {
                if (res.status === true) {
                    setLoading(false);
                    setDlist(res.data);
                    if (res.data.length > 0) {
                        setSamt(res.data[0].loan_amount);
                        setNdues(res.data[0].dues);
                        const totalPrincipal = res.data.reduce((acc, item) => acc + (parseFloat(item.principal_amount) || 0), 0);
                        const totalInterest = res.data.reduce((acc, item) => acc + (parseFloat(item.interest_amount) || 0), 0);
                        const totalAmount = res.data.reduce((acc, item) => acc + (parseFloat(item.total) || 0), 0);
                        setPamt(totalPrincipal.toFixed(2));
                        setIamt(totalInterest.toFixed(2));
                        setTamt(totalAmount.toFixed(2));
                    }
                }
            })
            // loancreate(temp).then((res) => {
            //     if (res.status === true) {
            //         setLoading(false);
            //         toast.success(res.message);
            //         navigate("/loan/loanapproval");
            //     } else {
            //         setLoading(false);
            //         setPerror(res.message);
            //     }
            // });
        }
    }

    function loansubmit(e){
        e.preventDefault();
        setPerror("");
        setPsubmit(true);
        if (grpid !== "" && memid !== "" && staff !== "" && schid !== "" && ldate !== "" && dsdate !== "") {
            setLoading(true);
            const temp = new FormData();
            temp.append("loan_group", grpid);
            temp.append("loan_member", id);
            temp.append("loan_staff", staff);
            temp.append("loan_scheme", schid);
            temp.append("loan_date", ldate);
            temp.append("loan_due_date", dsdate);
            temp.append("loan_insurance", entryfee);
            temp.append("loancount", dlist.length);
            for (let i = 0; i < dlist.length; i++) {
                temp.append(`loan_duedate_${i+1}`, dlist[i].due_date);
                temp.append(`loan_principle_${i+1}`, dlist[i].principal_amount);
                temp.append(`loan_interest_${i+1}`, dlist[i].interest_amount);
                temp.append(`loan_total_${i+1}`, dlist[i].total);
            }

            loancreate(temp).then((res) => {
                if (res.status === true) {
                    setLoading(false);
                    toast.success(res.message);
                    navigate("/loan/loanapproval");
                   
                } else {
                    setLoading(false);
                    setPerror(res.message);
                }
            });
        }
    }

    const [loading, setLoading] = useState(false);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Add Loan</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Loan</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Add Loan
                    </li>
                </ol>
            </div>
            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <Card.Header>
                                    <h2 className="main-content-title tx-24 mg-b-5">Add Loan</h2>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Group ID <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    value={grpid}
                                                    onChange={(e) => setGrpId(e.target.value)}
                                                    disabled
                                                >
                                                    <option value="">Select Group</option>
                                                    {glist.map((item, index) => {
                                                        return (
                                                            <option value={item.id} key={index}>
                                                                {item.group_name}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && grpid === "" && <span className="text-danger">Group is required</span>}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Member <span className="text-danger"> *</span>
                                                </label>
                                                <input type="text" className="form-control" placeholder="Enter Member" value={memid} onChange={(e) => setMemId(e.target.value)} disabled />
                                                {psubmit && memid === "" && <span className="text-danger">Member is required</span>}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Address
                                                </label>
                                                <textarea
                                                    rows="3"
                                                    className="form-control"
                                                    placeholder="Enter Address"
                                                    value={addr}
                                                    onChange={(e) => setAddr(e.target.value)}
                                                    disabled
                                                />
                                            </div>
                                        </Col>


                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Phone
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Phone"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    disabled
                                                />
                                            </div>
                                        </Col>

                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Aadhar
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Aadhar"
                                                    value={aadhar}
                                                    onChange={(e) => setAadhar(e.target.value)}
                                                    disabled
                                                />
                                            </div>
                                        </Col>


                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Staff
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={staff}
                                                    onChange={(e) => setStaff(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Staff
                                                    </option>
                                                    {slist.map((item, index) => {
                                                        return (
                                                            <option value={item.id} key={index} className={item.active === 0 ? 'text-danger' : ''} disabled={item.active === 0}>{item.staff_name}</option>
                                                        )
                                                    })}
                                                </select>
                                                {psubmit && staff === "" && <span className="text-danger">Staff is required</span>}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Scheme<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={schid}
                                                    onChange={(e) =>{setDlist([]); setSchId(e.target.value)}}
                                                >
                                                    <option value="" disabled>
                                                        Select Scheme
                                                    </option>
                                                    {sclist.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.id}>
                                                                {item.scheme_id}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                                {psubmit && schid === "" && <span className="text-danger">Scheme is required</span>}
                                            </div>
                                        </Col>

                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Loan Date <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Enter Loan Date"
                                                    value={ldate}
                                                    onChange={(e) => setLDate(e.target.value)}
                                                />
                                                {psubmit && ldate === "" && <span className="text-danger">Loan Date is required</span>}
                                            </div>
                                        </Col>
                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Due Start Date <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Enter Due Start Date"
                                                    min={ldate}
                                                    value={dsdate}
                                                    onChange={(e) => {setDsDate(e.target.value); setDlist([])}}
                                                />
                                                {psubmit && dsdate === "" && <span className="text-danger">Due Start Date is required</span>}
                                            </div>
                                        </Col>

                                        <Col xl={4} sm={6}>
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Insurance Fee
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Insurance Fee"
                                                    value={entryfee}
                                                    onChange={handleFee}
                                                />
                                            </div>
                                        </Col>

                                    </Row>
                                    {perror && <span className="text-danger">{perror}</span>}

                                    <div className="text-end">
                                        <a className="btn btn-success" onClick={handlesubmit}>Preview</a>
                                    </div>
                                </Card.Body>
                            </Card>
                            {dlist.length > 0 &&
                                <Card>
                                     <Card.Header>
                                    <h2 className="main-content-title tx-24 mg-b-5">Loan Entries</h2>
                                </Card.Header>
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <h4 className="main-content-title tx-24 mg-b-5">Scheme Amount : {samt}</h4>
                                            </div>
                                            <div className="col-xl-6">
                                                <h4 className="main-content-title tx-24 mg-b-5">No of Dues : {ndues}</h4>
                                            </div>
                                        </div>
                                        <table className="responsive-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Due Date</th>
                                                    <th>Principle</th>
                                                    <th>Interest</th>
                                                    <th>Total Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dlist.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="input-field total-field"
                                                                    value={moment(item.due_date).format("DD-MM-YYYY")}
                                                                    readOnly
                                                                />
                                                            </td>

                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="input-field total-field"
                                                                    readOnly
                                                                    value={item.principal_amount}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="input-field total-field"
                                                                    readOnly
                                                                    value={item.interest_amount}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="input-field total-field"
                                                                    readOnly
                                                                    value={item.total}
                                                                />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan={2}>
                                                        <h4 className="text-center">Total</h4>
                                                    </td>
                                                    <td>
                                                        <h6 className="text-center">{pamt}</h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="text-center">{iamt}</h6>
                                                    </td>
                                                    <td>
                                                        <h6 className="text-center">{tamt}</h6>
                                                    </td>
                                                </tr>

                                            </tfoot>
                                        </table>

                                        <div className="text-end mt-2">
                                        <a className="btn btn-success" onClick={loansubmit}>Submit</a>
                                    </div>
                                    </Card.Body>
                                </Card>
                            }

                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}
